(function () {

seedWebApp.controller('SentEmailModalCtrl', EmailModal);
    function EmailModal($scope, $uibModal, $uibModalInstance, $document, ToastService, LogisticsService, sentEmailID, item) {
        var ctrl = this;

        console.log('sentEmailModal ' + sentEmailID, item);

        $scope.sentEmailID = sentEmailID;
        //$scope.item = item;

        LogisticsService.getSentEmail(sentEmailID).then(
            function (response) {
                $scope.item = response.data;
                $scope.item.Orders = item.Orders; //JRM TEMP
                $scope.item.shippingDocsLink = 'shippingDocs?id=' + $scope.item.LinkID;
            }, function (error) {
                console.log('ERROR', error);
            }
        );

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        }
        
    }
}) ();